import { render, staticRenderFns } from "./feeCollection.vue?vue&type=template&id=e259b55e"
import script from "./feeCollection.vue?vue&type=script&lang=js"
export * from "./feeCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports